import { css } from '@emotion/react';

/**
 * Global styles for transparent background export mode.
 *
 * Applied when roadmap PNG export template has transparentBackground enabled.
 * Uses CSS custom property to control background color throughout the export page.
 *
 * Note: !important is required to override:
 * - Tailwind's preflight/base styles
 * - MUI ScopedCssBaseline defaults
 * - Tempo UI theme defaults
 */
export const exportTransparentGlobalStyles = css`
  html.export-transparent {
    --export-bg-color: transparent;
  }

  html.export-transparent,
  html.export-transparent body,
  html.export-transparent #root {
    /* biome-ignore lint/complexity/noImportantStyles: Required to override Tailwind/MUI framework defaults */
    background: transparent !important;
    /* biome-ignore lint/complexity/noImportantStyles: Required to override Tailwind/MUI framework defaults */
    background-color: transparent !important;
  }
`;
